<template>
  <v-container>
    <v-btn color="primary" text class="text-h5 mt-10" @click="goBack()">
      <v-icon left>mdi-arrow-left</v-icon>
      {{ $t("common.back") }}
    </v-btn>
    <v-row class="text-h2 justify-center pa-10">
      {{ $t(`synergy.${update ? "update" : add ? "add" : "show"}.title`) }}
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="validate"
      :readonly="show"
    >
      <v-row class="justify-center">
        <v-col cols="12" sm="6" class="justify-end">
          <v-text-field
            v-model="synergy.reportedThresholdConcentrationOfUnami"
            :label="
              $t('synergy.form.label.reportedThresholdConcentrationOfumami')
            "
            required
          ></v-text-field>
          <v-text-field
            v-model="synergy.unamiPerception"
            :label="$t('synergy.form.label.umamiPerception')"
          ></v-text-field>
          <v-text-field
            v-model="synergy.unami"
            :rules="[(v) => !!v || $t('synergy.form.error.umami')]"
            :label="$t('synergy.form.label.umami')"
            required
          ></v-text-field>
          <v-text-field
            v-model="synergy.other"
            :label="$t('synergy.form.label.other')"
          ></v-text-field>
          <v-autocomplete
            :items="molecules"
            v-model="synergy.molecules"
            :label="$t('synergy.form.label.molecules')"
            :rules="[
              (v) => v.length !== 0 || $t('synergy.form.error.molecules'),
            ]"
            multiple
            return-object
            chips
            deletable-chips
            item-text="name"
            :append-icon="!show ? 'mdi-menu-down' : ''"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-form>
    <v-row class="justify-center">
      <v-btn
        v-if="!show"
        :disabled="!valid"
        color="success"
        class="ma-4"
        @click="validate"
      >
        {{ $t(`synergy.button.${update ? "update" : "add"}`) }}
      </v-btn>
      <v-btn
        v-if="this.update"
        :disabled="!valid"
        color="error"
        class="ma-4"
        @click="deleteItem"
      >
        {{ $t(`synergy.button.delete`) }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router";
import Vue, { ref } from "vue";
import { storeToRefs } from "pinia";
import { useSynergyStore } from "@/store/synergyStore";
import { useMoleculeStore } from "@/store/moleculeStore";
import { useUserStore } from "@/store/userStore";
import i18n from "@/i18n";
import { POSITION, TYPE } from "vue-toastification";

export default {
  data: () => ({
    menu: false,
    valid: true,
    store: useSynergyStore(),
    userStore: useUserStore(),
    moleculeStore: useMoleculeStore(),
    synergy: ref(null),
    molecules: ref([]),
  }),
  props: {
    add: Boolean,
    update: Boolean,
    show: Boolean,
  },
  beforeMount() {
    if ((this.update || this.add) && !this.userStore.isWriter()) {
      Vue.$toast(i18n.t("synergy.toast.access.error"), {
        timeout: 2000,
        position: POSITION.TOP_CENTER,
        type: TYPE.ERROR,
      });
      this.goBack();
      return;
    }
    this.synergy = storeToRefs(this.store).synergy;
    this.molecules = storeToRefs(this.moleculeStore).molecules;
    this.moleculeStore.getMolecules();
    if (!this.add) {
      this.store.getSynergyById(parseInt(router.currentRoute.params.id));
    }
  },
  methods: {
    validate() {
      if (!this.show && this.$refs.form.validate()) {
        if (this.update) {
          this.store.updateSynergy().then(() => this.goBack());
        } else {
          this.store.addSynergy().then(() => this.goBack());
        }
      }
    },
    goBack: function () {
      this.store.$reset();
      router.go(-1);
    },
    deleteItem() {
      if (confirm(this.$t("synergy.delete.confirm"))) {
        this.store.deleteSynergy(this.synergy.id);
        this.goBack();
      }
    },
  },
};
</script>
